import { useCallback, useEffect, useState } from 'react'
import {
  getDivisions,
  getStore,
  getZones,
} from '../../../../utils/methods/geServiceWithItemsFormat'
import { Item } from '../../../../utils/types/generals'
import { useFilter } from '../../../../hooks/filter'
import { endOfWeek, startOfWeek, format } from 'date-fns'
import { Constants } from '../../../../utils/constants'
import { Roles } from '../../../../utils/enums'
import { getUserRole } from '../../../../service/auth'
import { useDashboardMainContext } from './provider'
import { userServiceFetch } from '../../../../utils/constants/callService'

const dataDefault: any = {
  from: startOfWeek(Date.now(), { weekStartsOn: 1 }),
  to: endOfWeek(Date.now(), { weekStartsOn: 1 }),
}

const useBody = () => {
  const { setItems: setContextItem, getActionPlanData, getProgrammingData, getUnitsData } = useDashboardMainContext()
  const currentDate = `date_init=${format(
    startOfWeek(Date.now(), { weekStartsOn: 1 }),
    Constants.dateFormat3
  )}&date_end=${format(
    endOfWeek(Date.now(), { weekStartsOn: 1 }),
    Constants.dateFormat3
  )}`
  const [hrefButton, setHrefButton] = useState(false)
  const [items, setItems] = useState<Record<string, Record<string, (string | Item)[] | boolean>>>({})
  const { errors, filterData, onChange, query } = useFilter({
    formatFilter: {},
    defaultValues: {
      from: new Date(startOfWeek(Date.now(), { weekStartsOn: 1 })),
      to: new Date(endOfWeek(Date.now(), { weekStartsOn: 1 })),
    },
  })

  const openHref = () => { setHrefButton(true) }
  const closeHref = () => { setHrefButton(false) }

  const getUnitsItems = useCallback(async () => {
    const { items } = await getStore()
    const idList = items.map((item) => item.value.toString()) || []
    setContextItem(prev => ({ ...prev, unit: items, unitLoading: true }))
    setItems(prev => ({
      ...prev,
      units: {
        all: idList,
        items,
        loading: true
      }
    }))
    getActionPlanData({ unitList: idList})
    getProgrammingData({ unitList: idList})
    getUnitsData({ unitList: idList})
  }, [])

  const getAllUsers = async({adminRol}:{adminRol:boolean}) => {
    const response =  adminRol ? await userServiceFetch.userList(`${Roles.AGENT},${Roles.AUDIT}`) : await userServiceFetch.usersByStatus({addUserLogged:true})
    setContextItem(prev => ({ ...prev, users: (response ?? []).map(item => ({
      label: `${item.firstName ?? ''} ${item.lastName ?? ''} (Rol: ${item.role})`,
      value: item.id,
      roleId: item.roleId
    })), usersLoading: true }))
  }
  const getDivisionsAll = useCallback(async () => {
    const { items } = await getDivisions()
    setContextItem(prev => ({ ...prev, division: items, divisionLoading: true }))
    setItems(prev => ({
      ...prev,
      divisions: {
        items,
        loading: true
      }
    }))
  }, [])

  const getZonesAndClassAll = useCallback(async () => {
    const { fatherZones, childZones } = await getZones()
    setContextItem(prev => ({ 
      ...prev,
      zones: fatherZones,
      class: childZones,
      zonesnLoading: true,
      classnLoading: true,
    }))
    setItems(prev => ({
      ...prev,
      zonesAndClass: {
        zones: fatherZones,
        class: childZones,
        loading: true
      }
    }))
  }, [])

  useEffect(() => {

    const commonMethod = ({adminRol}:{adminRol:boolean}) => {
      getUnitsItems()
      getDivisionsAll()
      getZonesAndClassAll()
      getAllUsers({adminRol})
    }


    const methodsRoles: Record<Roles, () => void> = {
      [Roles.ADMIN]: () => { commonMethod({adminRol:true}) },
      [Roles.GERENT]: () => { commonMethod({adminRol:false}) },
      [Roles.SUPERVISOR]: () => { commonMethod({adminRol:false}) },
      [Roles.AGENT]: () => { commonMethod({adminRol:false}) },
      [Roles.SUPPORT]: () => { commonMethod({adminRol:false}) },
      [Roles.AUDIT]: () => { },
      [Roles.STORE]: () => { },
      [Roles.PARTNER]: () => { },
    }
    const role = getUserRole()
    if (!!role) {
      methodsRoles[role as Roles]()
    }
  }, [getUnitsItems, getDivisionsAll])

  return {
    unitIds: items.units,
    divisionsItems: items?.divisions,
    errors,
    filterData,
    zonesAndClass: items.zonesAndClass,
    query,
    currentDate,
    hrefButton,
    openHref,
    closeHref,
    onChange,
  }
}

export { useBody, dataDefault, }
